import { createSlice } from "@reduxjs/toolkit";
import { PAGELENGTH } from "components/common/ListLayout";
import Api from "services/api";

export const initialState = {
  interpreterTranslations: [],
  error: null,
  loader: false,
  total: 1,
  is_more: false,
  current_page: 1,
  per_page: PAGELENGTH,
  last_page: 1,
};

export const interpreterTranslationSlice = createSlice({
  name: "interpreterTranslators",
  initialState: initialState,
  reducers: {
    setTranslations: (state, { payload }) => {
  state.interpreterTranslations = payload?.data ?? [];
  state.total = payload?.total ?? 0;
  state.is_more = payload?.is_more ?? false;
  state.last_page = payload?.last_page ?? 1;
  state.current_page = payload?.current_page ?? 1;
  state.per_page = payload?.per_page ?? PAGELENGTH;
},
    setMoreTranslations: (state, { payload }) => {
      state.interpreterTranslations = state.interpreterTranslations.concat(
        payload.data
      );
      state.total = payload?.data?.total;
      state.is_more = payload?.data?.is_more;
      state.last_page =  payload?.data.last_page;
      state.current_page = payload?.data?.current_page;
      state.per_page = payload?.data?.per_page;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    clearAllTranslations: (state) => {
      state.interpreterTranslations = [];
      state.error = null;
      state.loader = false;
      state.total = 0;
      state.is_more = false;
      state.current_page = 1;
      state.per_page = PAGELENGTH;
      state.last_page = 1;
    },
  },
});

// Fetch translation
export const fetchInterpreterTranslationsList =
  (page, params, disableLoader, asyncMode) => async (dispatch) => {
    if (!disableLoader) dispatch(setLoader(true));
    try {
      const result = await Api.fetchInterpreterTranslationList(page, params);
      // if (result.status >= 200 && result.status < 300) {
      //   if (page > 1) {
      //     if (asyncMode) {
      //       console.log("result", result);
      //       return result?.data?.data;
      //     } else {
      //       dispatch(
      //         setMoreTranslations({ data: result.data.data, ...result.data })
      //       );
      //       if (!disableLoader) dispatch(setLoader(false));
      //     }
      //   } else {
      //     if (asyncMode) {
      //       return result?.data?.data;
      //     } else {
      //       dispatch(
      //         setTranslations({ data: result.data.data, ...result.data })
      //       );
      //       if (!disableLoader) dispatch(setLoader(false));
      //     }
      //   }
      // } else if (result?.status === 422) {
      //   if (asyncMode) {
      //     return [];
      //   } else {
      //     dispatch(setError(result.data));
      //     if (!disableLoader) dispatch(setLoader(false));
      //   }
      // }

      if (result.status >= 200 && result.status < 300) {
        const data = result?.data;
        if (page > 1) {
          dispatch(setTranslations( data ));
          if (!disableLoader) dispatch(setLoader(false));
        } else {
          dispatch(setTranslations( data ));
          if (!disableLoader) dispatch(setLoader(false));
        }
      } else if (result?.status === 422) {
        if (asyncMode) return [];
        dispatch(setError(result.data));
        if (!disableLoader) dispatch(setLoader(false));
      }
    } catch (error) {
      console.log("error", error);
    }
  };

// Fetch translation by ID
export const getInterpreterTranslationById =
  (transId, callback) => async (dispatch) => {
    dispatch(setError(null));
    dispatch(setLoader(true));
    try {
      const json = await Api.fetchinterpreterTranslationById(transId);
      if (json.status >= 200 && json.status < 300) {
        callback(true, json.data.data);
      } else {
        callback(false, json?.data?.message || 'Translation not accessible.');
      }
    } catch (error) {
      callback(false, 'Translation not accessible.');
    }
    dispatch(setLoader(false));
  };

// Update translation
export const updateClientTranslation =
  (data, itemId, callback) => async (dispatch) => {
    dispatch(setError(null));
    dispatch(setLoader(true));
    try {
      const json = await Api.updateTranslation(data, itemId);
      if (json.status >= 200 && json.status < 300) {
        callback(true, json.data.message);
      } else if (json.status === 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(setLoader(false));
  };

// remove Translation
export const removeClientTranslation =
  (itemId, callback) => async (dispatch) => {
    dispatch(setError(null));
    dispatch(setLoader(true));
    try {
      const json = await Api.removeTranslation(itemId);
      if (json.status >= 200 && json.status < 300) {
        callback(true, json.data.message);
      } else if (json.status === 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(setLoader(false));
  };

export const {
  setTranslations,
  setMoreTranslations,
  setError,
  setLoader,
  clearAllTranslations,
} = interpreterTranslationSlice.actions;

export default interpreterTranslationSlice.reducer;
export const clientTranslationSelector = (state) =>
  state.interpreterTranslators;
